module.exports = "magnifier-smaller"